import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'
import './index.css'

import * as serviceWorker from './serviceWorker'
import { APP_VERSION } from './config/version'
console.log(APP_VERSION)

const rootElement = document.getElementById('root')

// Render the App at the root element
ReactDOM.render(<App />, rootElement)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
